let apiBase = {
  getImgCaptcha: '/api/activity/getImgCaptcha',
  checkImgCaptcha: '/api/activity/checkImgCaptcha',
  registrations: '/api/activity/registrations',
}
let ActivitySeverObject = null
class ActivitySever {
  constructor() {}
  getImgCaptcha(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.getImgCaptcha,
      data: params
    })
  }
  checkImgCaptcha(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.checkImgCaptcha,
      data: params
    })
  }
  registrations(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.registrations,
      data: params
    })
  }
}

function singleActivitySever() {
  if (ActivitySeverObject === null) {
    ActivitySeverObject = new ActivitySever()
  }
  return ActivitySeverObject
}
export default singleActivitySever()